import React from 'react';
import Text from 'components/Text';
import { Visibility } from 'components/Visibility';
import '../styles.scss';
 
const AutoCompleteCompanyModel: React.FC = (props: any) => {
  const { item } = props;
  const viewCustomerData = () => {
    const isJuridicalPerson = item?.documentNumber?.length === 14;
    const documentType = isJuridicalPerson ? 'CNPJ' : 'CPF';

    if (item.crmCustomerCode) {
      return `${documentType}: ${item.documentNumber} - Cód Interno: ${item.identifier} - Cód Cliente: ${item.crmCustomerCode}`;
    } 

    return `${documentType}: ${item.documentNumber} - Cód Interno: ${item.identifier}`;
  };
 
  return (
    <>
      <Text className="text-left color-blue-gray pt-1" size={13}>
        {item.companyName}
      </Text>
      <div className="d-flex">
        <Text className="text-left pb-1" size={10}>
          {viewCustomerData()}
        </Text>
        <Visibility visible={false}>
        {item.tenantIdDescription 
          ? <p className="flag-company"> {item?.tenantIdDescription} </p>
          : null}
        </Visibility>
      </div>
    </>
  );
};
 
export default AutoCompleteCompanyModel;